document.addEventListener('DOMContentLoaded', ()=> {
  document.querySelectorAll('.sit-icon').forEach( button => {
    button.addEventListener('mouseover', () => {
      const currentActiveButton = document.querySelector('.sit-icon.active')
      if( currentActiveButton && button != currentActiveButton) {
        document.querySelector(`.sit-item.active`).classList.remove('active')
        currentActiveButton.classList.remove('active')
        button.classList.toggle('active')
        console.log(`.sit-item[data-target="${button.dataset.target}"]`)
        document.querySelector(`.sit-item[data-target="${button.dataset.target}"]`).classList.add('active')
      }
    })
  })
})